import React from "react";

import ROUTES from "@app/common/routes";
import { withQueryParams } from "@app/common/utils";

import Alert from "@rui/Alert";
import Link from "@rui/Link";

const PurchaseLicensesAlert = ({
  embedded = false,
  inTrialPeriod,
  licenses,
}: {
  embedded?: boolean;
  inTrialPeriod: boolean;
  licenses: { numActive: number; numUnclaimed: number };
}) => {
  const addLicensesRoute = withQueryParams(ROUTES.BILLING, {
    add_licenses: "true",
  });
  const addLicensesAction = inTrialPeriod ? "Add" : "Purchase";

  if (licenses.numUnclaimed > 0) {
    return (
      <Alert severity="info" embedded={embedded}>
        <Link to={addLicensesRoute} underline>
          {addLicensesAction} additional licenses
        </Link>{" "}
        to invite more people to your Workspace.
      </Alert>
    );
  }

  return (
    <Alert severity="info" embedded={embedded} alignItems="flex-start">
      All licenses ({licenses.numActive}) are in use.{" "}
      <Link
        to={addLicensesRoute}
        sx={{ textDecoration: "underline" }}
        openInBrowser
      >
        {addLicensesAction} additional licenses
      </Link>{" "}
      to invite people to your Workspace.
    </Alert>
  );
};

export default PurchaseLicensesAlert;
